import React from 'react';
import { Utils } from '../../../../../shared';
import PlanAlignmentCards from './PlanAlignmentCards';
import CampaignDetailInfoCards from './CampaignDetailInfoCards';

/**
 * CampaignOverviewSection Component (Skeleton)
 * 
 * This component will display:
 * 1. Campaign Header Card - with campaign name, date range, synthesis ID, client code, product code
 * 2. Taxonomy Compliance Card - circular progress showing 100% compliance
 * 3. Linked Creatives Count Card
 * 4. Plan Alignment Card - with order progress bar and channel breakdown chart
 * 
 * Props:
 * @param {Object} campaignData - Campaign details including name, dates, metrics
 * @param {String} campaignId - Campaign ID
 * 
 * TODO for teammate:
 * - Implement campaign header with all fields from screenshot
 * - Add circular progress for taxonomy compliance (100%)
 * - Create linked creatives counter (0)
 * - Build plan alignment section with:
 *   - Order progress bar (0% - $0.00 / $400,000.00)
 *   - Channel breakdown chart (Planned vs Ordered)
 *   - Include non-digital checkbox
 * - Add "Edit taxonomy" button functionality
 * - Implement chart visualization for channel breakdown
 */
const CampaignOverviewSection = ({ campaignData,orderedData,systemParametersData}) => {
    const isLocalValue = (label,data) => {
        let budget = data?.[label] || 0;
        if(systemParametersData?.data?.isLocal){
            // For MOH values,only local added middle so can use [label+'_local'],so added condition for that , backend label is not changing.
            budget = 'ordered_total_moh' == label ? data?.['ordered_total_local_moh'] : data?.[label+'_local'];
        }
        return budget;
    };
    return (
        <div className="campaign-overview-section">
            <PlanAlignmentCards
                planningSummary={{
                    plannedAmount: isLocalValue('campaign_total_budget', campaignData),
                    mohOrderedAmount: orderedData?.parent_campaign_details?.channels
                        ? orderedData?.parent_campaign_details?.channels
                            .reduce(
                                (sum, data) => sum + (isLocalValue('ordered_total_moh',data)),
                            0)
                        : 0,
                    orderedAmount: orderedData?.parent_campaign_details?.channels
                        ? orderedData?.parent_campaign_details?.channels
                            .reduce(
                                (sum, data) => sum + (isLocalValue('ordered_total',data)),
                            0)
                        : 0,
                }}
                channelsData={campaignData.media_attributes.channels}
                taxonomyCompliance={{
                    campaignData: campaignData,
                    versionOneApi: 'V3',
                }}
                orderedData={orderedData}
                islocalCurrency={{ islocal: systemParametersData?.data?.isLocal,currencyName: campaignData?.local_currency_name }}

            />

        </div>
    );
};

export default CampaignOverviewSection;
